import { css } from 'lit';

export const adminPubsubViewStyles = [
  css`

    :host {
      background: var(--blue-1);
    }

    form {
      margin: var(--view-item-spacing) 0;
    }

    sl-switch {
      display: block;
      margin: 2rem 0;
    }
    
  `,
];
